/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in page dashboard
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – nanmnth@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import repository from './repository';

const dataInit = {
    user_id: 0,
    user_name: '',
    user_kana: '',
    user_name_alias: '',
    user_kana_alias: '',
    area_cd: '',
    area_name: '',
    office_cd: '',
    office_name: '',
    password: '',
    email_address: '',
    email_address_2: '',
    email_check: '',
    phone_number: '',
    quote_approval_lv: '0',
    authority_kubun: '0',
    authority_name: '',
    banned: '1',
    controlCenter: '0',
    path_image: '',
    image: ''
};

const dataTable = [
    {
        user_id: '',
        user_name: '',
        user_kana: '',
        area_cd: '',
        area_name: '',
        office_cd: '',
        office_name: '',
        password: '',
        email_address: '',
        email_address_2: '',
        phone_number: '',
        quote_approval_lv: '',
        authority_kubun: '',
        authority_name: '',
        banned: '',
        controlCenter: '',
        isSelected: '',
        image: ''
    }
];

export default {
    namespaced: true,
    state: {
        isSuccess: false,
        data: { ...dataInit },
        dataTable: { ...dataTable },
        selectOptionKey: ['id', 'content'],
        totalRows: 0,
        listData: [],
        listDroppedItem: [],
        data_select: {
            prohibitedUse: [
                {
                    code: 1,
                    name: '使用可'
                },
                {
                    code: 2,
                    name: '禁止'
                }
            ],
            authority_kubun: [
                {
                    code: 0,
                    name: '一般'
                },
                {
                    code: 99,
                    name: '管理'
                }
            ],
            quote_approval_lv: [
                {
                    code: 0,
                    name: '依賴者'
                },
                {
                    code: 1,
                    name: '承認者'
                }
            ],
            control_center: [
                {
                    code: 0,
                    name: '権限なし'
                },
                {
                    code: 1,
                    name: '権限あり'
                }
            ]
        },
        msgNoData: '該当するデータが存在しません。'
    },
    mutations: {
        resetDataInit(state, data) {
            if (data?.mode) {
                state.data = { ...dataInit };
                state.data.user_id = data.user_id;
            } else {
                state.data = { ...dataInit };
            }
        },
        setListData(state, data) {
            state.listData = data ?? [];
            state.msgNoData = '';
        },
        setListDroppedItem(state, data) {
            state.listDroppedItem = data ?? [];
        },
        setData(state, data) {
            state.data = {
                ...data,
                email_check: data.email_address_2 ?? ''
            };
        },
        setTotalRows(state, data) {
            state.totalRows = data;
        },
        setPageNavigation(state, data) {
            state.data.pageNo = data.currentPage;
            state.data.pageSize = data.perPage;
        },
        setPageNo(state, data) {
            state.data.pageNo = data;
        },
        addDropItem(state, item) {
            // const droppedIndex = item.index;
            const userId = item.user_id;
            const duplicate = state.listDroppedItem.filter((item) => item.user_id === userId);
            if (!duplicate.length) {
                item.isDrop = true;
                state.listDroppedItem.push(item);
            }
        },
        deleteRowItem(state, index) {
            state.listDroppedItem.splice(index, 1);
        }
    },
    actions: {
        getUserInfo(context, input) {
            try {
                repository.getUserInfo(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code == 200) {
                        context.commit('setData', {
                            ...data.Data
                        });
                        if (input.callback) {
                            input.callback();
                        }
                    }
                });
            } catch (e) {
                console.log('Action get user info data screen: ' + e.message);
            }
        },
        getAreaInfo(context, input) {
            try {
                repository.getAreaInfo(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code == 200) {
                        if (input.callback) {
                            input.callback(data.Data);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Data.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        },
        getOfficeInfo(context, input) {
            try {
                repository.getOfficeInfo(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code == 200) {
                        if (input.callback) {
                            input.callback(data.Data);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Data.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        },
        storeUserInfo(context, input) {
            try {
                repository.storeUserInfo(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (input.callback) {
                            input.callback(data);
                        }
                    } else if (data.Code === 422) {
                        if (input.onErrorValidate) {
                            input.onErrorValidate(data.Message);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Data.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        },
        getListDataDroppedItem(context, input) {
            try {
                repository.getListDataDroppedItem(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        const ListDroppedItem = data.Data;
                        if (ListDroppedItem.length > 0) {
                            context.commit('setListDroppedItem', ListDroppedItem);
                        } else {
                            context.commit('setListDroppedItem', []);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        },
        saveListDataDroppedItem(context, input) {
            try {
                repository.saveListDataDroppedItem(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (input.callback) {
                            input.callback(data);
                        }
                    } else if (data.Code === 422) {
                        if (input.onErrorValidate) {
                            input.onErrorValidate(data.Message);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Data.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        },
        deleteRowItemAPI(context, input) {
            try {
                repository.deleteRowItemAPI(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (input.callback) {
                            input.callback(data);
                        }
                    } else if (data.Code === 422) {
                        if (input.onErrorValidate) {
                            input.onErrorValidate(data.Message);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Data.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        },
        deleteListDataItem(context, input) {
            try {
                repository.deleteListDataItem(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (input.callback) {
                            input.callback(data);
                        }
                    } else if (data.Code === 422) {
                        if (input.onErrorValidate) {
                            input.onErrorValidate(data.Message);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Data.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        },
        uploadFile(context, request) {
            try {
                repository.uploadFileImage(request.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (request.callback) {
                            request.callback(data);
                        }
                    } else if (data.Code === 422) {
                        if (request.onErrorValidate) {
                            request.onErrorValidate(data.Message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action upload file image: ' + e.message);
            }
        },
        getImage(context, rawPath) {
            try {
                repository.getImage(rawPath).then((res) => {
                    if (res.status === 200) {
                        const imgElement = document.querySelector('.imagePreview img');
                        if (res.data.size > 0) {
                            const blob = res.data;
                            const objectUrl = URL.createObjectURL(blob);
                            imgElement.src = objectUrl;
                            imgElement.style.display = 'block';
                        } else {
                            imgElement.src = '#';
                            imgElement.style.display = 'none';
                        }
                    }
                });
            } catch (e) {
                console.log('Action get image: ' + e.message);
            }
        }
    }
};
